var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-input-wrapper",style:(_vm.wrapperStyle)},[_c('el-input',_vm._g(_vm._b({style:(_vm.inputStyle),scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,slot){return {key:slot,fn:function(){return [_vm._t(slot)]},proxy:true}})],null,true)},'el-input',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }